import { render, staticRenderFns } from "./AssignRoles.vue?vue&type=template&id=63023a3a&scoped=true&"
import script from "./AssignRoles.vue?vue&type=script&lang=js&"
export * from "./AssignRoles.vue?vue&type=script&lang=js&"
import style0 from "./AssignRoles.vue?vue&type=style&index=0&id=63023a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63023a3a",
  null
  
)

export default component.exports